import React, { useState } from 'react'
import { Col, Panel, Row } from 'rsuite'
import RenderAssessmentView from './RenderAssessmentView'

export default function PrePostTestView({ schema, ...props }) {
  return (
    <>
      <Panel
        bordered
        collapsible
        defaultExpanded
        shaded
        style={{ marginBottom: 120, marginTop: 10 }}
        header={schema.header}
      >
        <Row style={{ marginBottom: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <b>{schema.email.label} : </b>
            {schema.email.value}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <b>{schema.name.label} : </b>
            {schema.name.value}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <b>{schema.projectCode.label} : </b>
            {schema.projectCode.value}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <RenderAssessmentView assessments={schema.assessments || []} />
        </Row>
      </Panel>
    </>
  )
}
